// product.html 商品の画像を拡大するカルーセル表示
// modal_image_carousel.html で読み込み

window.onload = () => {
    // クリックした写真をトップにしてカルーセルを表示
    const disp_carousel: HTMLElement[] = Array.from(document.querySelectorAll('.carousel-thumb'))
    const carouselItems: HTMLElement[] = Array.from(document.querySelectorAll('.carousel-item'))
    disp_carousel.forEach(element => {
        element.onclick = (e) => {
            const car_index = Number(element.id.split('-')[1]);
            carouselItems.forEach((el) => {
                el.classList.remove('active')
            })
            carouselItems[car_index].classList.add('active')
        }
    });
}

export { }